import SvgIcon, { SvgIconProps } from "./SvgIcon";

const InstagramColoredIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M19.1924 6.12857C19.1924 5.39741 18.5998 4.80703 17.8714 4.80703C17.1429 4.80703 16.5498 5.39741 16.5498 6.12857C16.5498 6.85704 17.1429 7.44742 17.8714 7.44742C18.5998 7.44742 19.1924 6.85704 19.1924 6.12857Z"
        fill="url(#paint0_linear_2402_14)"
      />
      <path
        d="M20.9527 16.4444C20.9038 17.517 20.7244 18.0997 20.5754 18.4868C20.3753 19 20.1367 19.3669 19.7497 19.7518C19.3669 20.1367 19 20.3748 18.4868 20.5727C18.0997 20.7238 17.5148 20.9038 16.4422 20.9549C15.2827 21.006 14.9391 21.0169 11.9986 21.0169C9.06089 21.0169 8.71458 21.006 7.55502 20.9549C6.48248 20.9038 5.90026 20.7238 5.51317 20.5727C4.99728 20.3748 4.63306 20.1367 4.24818 19.7518C3.86056 19.3669 3.62192 19 3.42458 18.4868C3.2756 18.0997 3.09352 17.517 3.04728 16.4444C2.99077 15.2849 2.98041 14.9358 2.98041 12.0014C2.98041 9.06089 2.99077 8.71458 3.04728 7.55502C3.09352 6.48248 3.2756 5.90026 3.42458 5.5099C3.62192 4.99728 3.86056 4.63249 4.24818 4.24761C4.63306 3.86329 4.99728 3.62461 5.51317 3.42458C5.90026 3.27291 6.48248 3.09568 7.55502 3.04459C8.71458 2.99346 9.06089 2.98041 11.9986 2.98041C14.9391 2.98041 15.2827 2.99346 16.4422 3.04459C17.5148 3.09568 18.0997 3.27291 18.4868 3.42458C19 3.62461 19.3669 3.86329 19.7497 4.24761C20.1367 4.63249 20.3753 4.99728 20.5754 5.5099C20.7244 5.90026 20.9038 6.48248 20.9527 7.55502C21.0065 8.71458 21.0195 9.06089 21.0195 12.0014C21.0195 14.9358 21.0065 15.2849 20.9527 16.4444ZM22.9331 7.4648C22.8793 6.29273 22.6945 5.49197 22.4199 4.79452C22.1405 4.07094 21.766 3.45773 21.1527 2.84452C20.5423 2.23405 19.9291 1.85947 19.2055 1.5768C18.5053 1.30498 17.7072 1.11795 16.5346 1.06687C15.362 1.01031 14.9875 1 11.9986 1C9.0125 1 8.63524 1.01031 7.46264 1.06687C6.29273 1.11795 5.49523 1.30498 4.79179 1.5768C4.07094 1.85947 3.45773 2.23405 2.84725 2.84452C2.23404 3.45773 1.85947 4.07094 1.57733 4.79452C1.3055 5.49197 1.12068 6.29273 1.06413 7.4648C1.01305 8.6374 1 9.0125 1 12.0014C1 14.9875 1.01305 15.362 1.06413 16.5346C1.12068 17.7045 1.3055 18.5047 1.57733 19.2055C1.85947 19.9263 2.23404 20.5423 2.84725 21.1527C3.45773 21.7632 4.07094 22.1405 4.79179 22.4227C5.49523 22.6945 6.29273 22.8793 7.46264 22.9331C8.63524 22.987 9.0125 23 11.9986 23C14.9875 23 15.362 22.987 16.5346 22.9331C17.7072 22.8793 18.5053 22.6945 19.2055 22.4227C19.9291 22.1405 20.5423 21.7632 21.1527 21.1527C21.766 20.5423 22.1405 19.9263 22.4199 19.2055C22.6945 18.5047 22.8793 17.7045 22.9331 16.5346C22.987 15.362 23 14.9875 23 12.0014C23 9.0125 22.987 8.6374 22.9331 7.4648Z"
        fill="url(#paint1_linear_2402_14)"
      />
      <path
        d="M11.9987 15.6648C9.97476 15.6648 8.33247 14.0252 8.33247 12.0013C8.33247 9.97413 9.97476 8.33241 11.9987 8.33241C14.0232 8.33241 15.6676 9.97413 15.6676 12.0013C15.6676 14.0252 14.0232 15.6648 11.9987 15.6648ZM11.9987 6.34926C8.87881 6.34926 6.35205 8.88144 6.35205 12.0013C6.35205 15.1185 8.87881 17.648 11.9987 17.648C15.1185 17.648 17.648 15.1185 17.648 12.0013C17.648 8.88144 15.1185 6.34926 11.9987 6.34926Z"
        fill="url(#paint2_linear_2402_14)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2402_14"
          x1="1.19839"
          y1="22.7725"
          x2="21.1676"
          y2="2.80342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD521" />
          <stop offset="0.05" stopColor="#FFD521" />
          <stop offset="0.501119" stopColor="#F50000" />
          <stop offset="0.95" stopColor="#B900B4" />
          <stop offset="0.950079" stopColor="#B900B4" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2402_14"
          x1="1.19844"
          y1="22.7999"
          x2="21.184"
          y2="2.81435"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD521" />
          <stop offset="0.05" stopColor="#FFD521" />
          <stop offset="0.501119" stopColor="#F50000" />
          <stop offset="0.95" stopColor="#B900B4" />
          <stop offset="0.950079" stopColor="#B900B4" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2402_14"
          x1="1.20366"
          y1="22.8005"
          x2="21.1844"
          y2="2.81967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD521" />
          <stop offset="0.05" stopColor="#FFD521" />
          <stop offset="0.501119" stopColor="#F50000" />
          <stop offset="0.95" stopColor="#B900B4" />
          <stop offset="0.950079" stopColor="#B900B4" />
          <stop offset="1" stopColor="#B900B4" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default InstagramColoredIcon;
